import Vue from 'vue';
import Router from 'vue-router';

const Login = () =>
    import ('@/views/login/login.vue');
const Register = () =>
    import ('@/views/register/register.vue');
const Index = () =>
    import ('@/views/dashboard/index.vue');
const Layout = () =>
    import ('@/views/layout/Layout.vue');
const GoodsList = () =>
    import ('@/views/goodsList/goodsList.vue');
const Details = () =>
    import ('@/views/details/index.vue');
const Discount = () =>
    import ('@/views/discount/index.vue');
const Strategy = () =>
    import ('@/views/strategy/index.vue');
const ModlueClassify = () =>
    import ('@/views/modlueClassify/index.vue');
const Clothing01 = () =>
    import ('@/views/modlueClassify/components/clothing.vue');
const Shopping = () =>
    import ('@/views/shopping/index.vue');
const StrategyDetail = () =>
    import ('@/views/strategyDetail/index.vue');
const Clothing = () =>
    import ('@/views/clothing/index.vue');
const PurchaseNote = () =>
    import ('@/views/purchaseNote/index.vue')
const Result = () =>
    import ('@/views/result/index.vue')
const Settlement = () =>
    import ('@/views/settlement/index.vue')

const CashierDesk = () =>
    import ('@/views/cashierDesk/index.vue')
const Forget = () =>
    import ('@/views/forget/index.vue')
const CustomMade = () =>
    import ('@/views/customMade/index.vue')
const Coupon = () =>
    import ('@/views/coupon/index.vue')

const Modification = () =>
    import ('@/views/modification/index.vue')
const Introduce = () =>
        import ('@/views/introduce/index.vue')
    // const Statement = () =>
    //         import ('@/views/register/statement.vue')
Vue.use(Router);
export default new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: [{
        path: '*',
        redirect: '/dashboard/index',
    }, {
        path: '/dashboard',
        component: Layout,
        redirect: '/dashboard/index',
        name: '首页',
        children: [
            { path: 'index', component: Index, name: '首页' },
            { path: 'customMade', component: CustomMade, name: '定制' },
            { path: 'goodsList', component: GoodsList, name: '商品列表页' },
            { path: 'details', component: Details, name: '商品详情页' },
            { path: 'discount', component: Discount, name: '拼采' },
            { path: 'strategy', component: Strategy, name: '攻略' },
            { path: 'strategyDetail', component: StrategyDetail, name: '攻略详情' },
            { path: 'clothing', component: Clothing, name: '服装' },
            { path: 'introduce', component: Introduce, name: '公司介绍' },
        ]
    }, {
        path: '/result',
        component: Result,
        redirect: '/result/purchaseNote',
        name: '结算',
        children: [
            { path: 'purchaseNote', component: PurchaseNote, name: '我的采购页' },
            { path: 'settlement', component: Settlement, name: '结算页' },
            { path: 'register', component: Register, name: '欢迎注册' },
            { path: 'cashierDesk', component: CashierDesk, name: '收银台' },
            { path: 'shopping', component: Shopping, name: '我的采购单' },
            { path: 'login', component: Login, name: '登录页' },
            { path: 'forget', component: Forget, name: '忘记密码' },
            { path: 'coupon', component: Coupon, name: '领取优惠劵' },
            { path: 'modification', component: Modification, name: '修改密码' },
            // { path: 'statement', component: Statement, name: ' 法律声明及隐私权政策' }
        ]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js